"use strict";

import { retailSalesConstants } from "../_constants";

export const INITIAL_RETAIL_SALES_STATE = {
     winnerList : [],
     winnerFilterOptions : { areas: [], dealers: [], jobRoles: [] },
     activationReport : { rows: [], totalCount: 0, page: 1, pageSize: 10 },
     activationReportExport : null,
     winnerVouchers : [],
     resendActivationResult : null,
     addWinnersResult : null,
     updateWinnerResult : null,
     dealerList : [],
     dealerLookupList : [],
     dealerListPage : { dealers: [], totalCount: 0 },
     jobTitleList : [],
     saveJobTitlesResult : null,
     saveDealersResult : null,
};

export function retailSales(state = INITIAL_RETAIL_SALES_STATE, action) {
    switch (action.type) {
     case retailSalesConstants.RETAIL_SALES_GET_ACTIVATION_REPORT_COMPLETE:
          return {
               ...state,
               activationReport: action.payload,
          };
     case retailSalesConstants.RETAIL_SALES_GET_ACTIVATION_REPORT_EXPORT_COMPLETE:
          return {
               ...state,
               activationReportExport: action.payload,
          };
     case retailSalesConstants.RETAIL_SALES_CLEAR_ACTIVATION_REPORT_EXPORT:
          return {
               ...state,
               activationReportExport: null,
          };
     case retailSalesConstants.RETAIL_SALES_GET_WINNERS_COMPLETE:
          return {
               ...state,
               winnerList: action.payload,
          };
     case retailSalesConstants.RETAIL_SALES_GET_WINNER_FILTER_OPTIONS_COMPLETE:
          return {
               ...state,
               winnerFilterOptions: action.payload,
          };
     case retailSalesConstants.RETAIL_SALES_GET_WINNER_VOUCHERS_COMPLETE:
          return {
               ...state,
               winnerVouchers: action.payload,
          };
     case retailSalesConstants.RETAIL_SALES_RESEND_ACTIVATION_COMPLETE:
          return {
               ...state,
               resendActivationResult: action.payload,
          };
     case retailSalesConstants.RETAIL_SALES_GET_JOB_TITLES_COMPLETE:
          return {
               ...state,
               jobTitleList: action.payload,
          };
     case retailSalesConstants.RETAIL_SALES_DELETE_JOB_TITLE_COMPLETE:
          return {
               ...state,
               saveJobTitlesResult: { results: [] },
          };
     case retailSalesConstants.RETAIL_SALES_SAVE_JOB_TITLES_COMPLETE:
          return {
               ...state,
               saveJobTitlesResult: action.payload,
          };
     case retailSalesConstants.RETAIL_SALES_CLEAR_SAVE_JOB_TITLES_RESULT:
          return {
               ...state,
               saveJobTitlesResult: null,
          };
     case retailSalesConstants.RETAIL_SALES_DEALER_LIST_COMPLETE:
          return {
               ...state,
               dealerListPage: action.payload,
          };
     case retailSalesConstants.RETAIL_SALES_DEALER_LOOKUP_COMPLETE:
          return {
               ...state,
               dealerLookupList: action.payload,
          };
     case retailSalesConstants.RETAIL_SALES_GET_DEALERS_COMPLETE:
          return {
               ...state,
               dealerList: action.payload,
          };
     case retailSalesConstants.RETAIL_SALES_SAVE_DEALERS_COMPLETE:
          return {
               ...state,
               saveDealersResult: action.payload,
          };
     case retailSalesConstants.RETAIL_SALES_CLEAR_SAVE_DEALERS_RESULT:
          return {
               ...state,
               saveDealersResult: null,
          };
     case retailSalesConstants.RETAIL_SALES_ADD_WINNERS_COMPLETE:
          return {
               ...state,
               addWinnersResult: action.payload,
          };
     case retailSalesConstants.RETAIL_SALES_CLEAR_ADD_WINNERS_RESULT:
          return {
               ...state,
               addWinnersResult: null,
          };
     case retailSalesConstants.RETAIL_SALES_UPDATE_WINNER_COMPLETE:
          return {
               ...state,
               updateWinnerResult: action.payload,
          };
     case retailSalesConstants.RETAIL_SALES_CLEAR_UPDATE_WINNER_RESULT:
          return {
               ...state,
               updateWinnerResult: null,
          };
     case retailSalesConstants.RETAIL_SALES_CLEAR_WINNER_VOUCHERS:
          return {
               ...state,
               winnerVouchers: [],
               resendActivationResult: null,
          };
    }
    return state;
}
